/* eslint-disable gettext/no-variable-string */
import {
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { track } from '@eventbrite/datalayer-library';
import { Icon } from '@eventbrite/eds-icon';
import { ArrowRightChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { TrackableComponent } from '../../../../utils/TrackableComponent';
import { COLLECTION_TOUCHPOINT_DATA } from '../../constants/collectionTouchpoint';
import { HEAP_TRACKABLE_EVENT } from '../../constants/heap';
import styles from './CollectionTouchpoint.module.scss';

interface MariaTouchpointProps {
    placeId: string;
    activeCategory: string;
    currentPlace: string;
}

export const CollectionTouchpoint = (props: MariaTouchpointProps) => {
    const { placeId, activeCategory, currentPlace } = props;
    const {
        title,
        description,
        subtitle,
        eventBucketLabel,
        placeId_collection_map,
        iconSrc,
        buttonTitle,
        dataHeapId,
        dataTestId,
    } = COLLECTION_TOUCHPOINT_DATA[activeCategory];

    const isHoliday =
        activeCategory === SEASONAL_EVENTBRITE_CATEGORY ||
        activeCategory === NIGHTLIFE_EVENTBRITE_CATEGORY;

    const touchpointClass = classNames(styles.touchpoint, {
        [styles.holidayTouchpoint]: isHoliday,
    });

    const buttonClass = classNames(styles.exploreBtn, {
        [styles.holidayBtn]: isHoliday,
    });

    const buttonTextClass = classNames(styles.exploreBtnTypo, {
        [styles.holidayBtnText]: isHoliday,
    });
    const ctaLink = `/c/${placeId_collection_map[placeId]}`;

    const handleIntersect = () => {
        track({
            eventName: HEAP_TRACKABLE_EVENT,
            eventData: {
                eventBucketLabel: eventBucketLabel,
            },
        });
    };

    if (!Object.hasOwnProperty.call(placeId_collection_map, placeId)) {
        return null;
    }

    return (
        <TrackableComponent onIntersect={handleIntersect}>
            <div className={touchpointClass}>
                <img
                    src={iconSrc}
                    className={styles.mariaImg}
                    alt={eventBucketLabel}
                />
                <div
                    className={styles.touchpointDetails}
                    data-testid={dataTestId}
                >
                    <Typography className={styles.title} variant="body-md">
                        {title}
                    </Typography>
                    <Typography
                        className={styles.subtitle}
                        variant="heading-sm"
                    >
                        {gettext(subtitle ?? '', { currentPlace })}{' '}
                    </Typography>
                    <Typography
                        className={styles.description}
                        variant="body-md"
                    >
                        {description}
                    </Typography>
                </div>
                <a
                    className={buttonClass}
                    href={ctaLink}
                    data-heap-id={dataHeapId}
                >
                    <Typography
                        className={buttonTextClass}
                        variant="body-md-bold"
                    >
                        {gettext(buttonTitle, { currentPlace })}{' '}
                        <Icon type={<ArrowRightChunky />} />
                    </Typography>
                </a>
            </div>
        </TrackableComponent>
    );
};
